import $ from 'jquery';

export default function scrollToDiv() {
  $(document).on('click', 'a[href^="#"]', function(e) {
    let id = $(this).attr('href');

    if (id === '#' || $(this).hasClass('contact-modal__link-modal')) {
      return;
    }

    let $id = $(id);
    if ($id.length === 0) {
      return;
    }

    if (id == '#jetzt-bewerben') {
      if ($('#jetzt-bewerben').length >= 1) {
        $id = $('#jetzt-bewerben');
      } else {
        if ($('#rueckruf').length >= 1 ||  $('#bewerbung').length >= 1) {
          $('#rueckruf').hide();
          $('#bewerbung').show();
          $id = $('#bewerbung');
        }
      }
    }

    e.preventDefault();
    let headerHeight = $('.header').height();
    let pos = $id.offset().top - headerHeight - 20;
    let contentMenu = $('.content-menu').height();

    if ($(window).width() < 768) {
      pos = $id.offset().top - headerHeight - contentMenu - 20;
    }

    $('body, html').animate({scrollTop: pos}, 250);
  });
}
